import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { paths } from '../../../routes/paths';

export const Playbooks2FormPage: FC = () => {
    const navigate = useNavigate();
    const { groupId } = useParams();

    useEffect(() => {
        // Redirect to the main playbooks-2 page since forms are handled within the modal
        // The modal will handle the form state based on URL parameters
        navigate('/new/playbooks-2' + (groupId ? `?edit=${groupId}` : '?new=true'), { replace: true });
    }, [navigate, groupId]);

    return null;
};
